import {createReducer} from 'redux-act';
import {
  CLEAR_MAIN_PAGE_DATA,
  GET_ALL_PERIOD_CUSTOMERS_COUNT,
  GET_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS,
  GET_ALL_PERIOD_TOTAL_SALES,
  GET_ALL_PERIOD_TOTAL_SALES_SUCCESS,
  GET_ANALYTICS_INFO,
  GET_ANALYTICS_INFO_SUCCESS,
  GET_EMAIL_MARKETING_STATS,
  GET_EMAIL_MARKETING_STATS_SUCCESS,
  GET_INSIGHTS_PERFORMANCE,
  GET_INSIGHTS_PERFORMANCE_SUCCESS,
  GET_MANAGE_PRICE_URL_SUCCESS,
  GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT,
  GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS,
  GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES_SUCCESS,
  GET_PREV_WEEK_INSIGHTS_PERFORMANCE_SUCCESS,
  GET_SALES_PER_HOUR,
  GET_SALES_PER_HOUR_SUCCESS,
  GET_SALES_PER_ITEM,
  GET_SALES_PER_ITEM_SUCCESS,
  GET_SURVEY_STATS,
  GET_SURVEY_STATS_SUCCESS,
  GET_SURVEY_STATS_THIS_WEEK_SUCCESS,
  GET_TODAY_TOTAL_SALES,
  GET_TODAY_TOTAL_SALES_SUCCESS,
  GET_TOP_CUSTOMERS,
  GET_TOP_CUSTOMERS_SUCCESS,
  GET_YESTERDAY_TOTAL_SALES,
  GET_YESTERDAY_TOTAL_SALES_SUCCESS,
  SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT,
  SET_LOADING_ALL_PERIOD_TOTAL_SALES,
  SET_LOADING_ANALYTICS_INFO,
  SET_LOADING_EMAIL_MARKETING_STATS,
  SET_LOADING_GROWTH_INFO,
  SET_LOADING_INSIGHTS_PERFORMANCE,
  SET_LOADING_SALES_PER_HOUR,
  SET_LOADING_SALES_PER_ITEM,
  SET_LOADING_SURVEY_STATS,
  SET_LOADING_TODAY_TOTAL_SALES,
  SET_LOADING_TOP_CUSTOMERS,
  SET_LOADING_YESTERDAY_TOTAL_SALES,
  SET_OPEN_MODAL
} from 'store/mainPage/action';
import {findBestAndWorstHour} from 'helpers/functionUtils/mainPage';
import {INSIGHTS_PERFORMANCE_CARDS_INFO_MAIN_PAGE} from 'helpers/constants/Insights/performance';

const initialState = () => ({
  todayOrdersCount: 0,
  todayTotalSales: 0,
  loadingTodayTotalSales: false,
  yesterdayOrdersCount: 0,
  yesterdayTotalSales: 0,
  loadingYesterdayTotalSales: false,
  allPeriodOrdersCount: 0,
  prevWeekAllPeriodOrdersCount: 0,
  allPeriodTotalSales: 0,
  prevWeekAllPeriodTotalSales: 0,
  avrAllPeriodTotalSales: 0,
  loadingAllPeriodTotalSales: false,
  allPeriodCustomersCount: 0,
  prevWeekAllPeriodCustomersCount: 0,
  avgAllPeriodOrdersPerCustomer: 0,
  avgAllPeriodItemsPerOrder: 0,
  loadingAllPeriodCustomersCount: false,
  salesPerHour: [],
  loadingSalesPerHour: false,
  bestHour: null,
  bestSales: null,
  worstHour: null,
  worstSales: null,
  salesPerItem: [],
  loadingSalesPerItem: false,
  topCustomers: [],
  loadingTopCustomers: false,
  performanceInfo: [
    {
      title: 'emailMarketingRevenue',
      value: 0
    },
    {
      title: 'googleRevenue',
      value: 0
    },
    {
      title: 'commissionsSaved',
      value: 0
    },

    {
      title: 'positiveGmbReviews',
      value: 0
    },
    {
      title: 'returnCustomersOrders',
      value: 0
    },

    {
      title: 'acceleratedDeliveries',
      value: 0
    },
    {
      title: 'feedbackHandling',
      value: 0
    },
    {
      title: 'virtualAnsweringCalls',
      value: 0
    }
  ],
  prevWeekCommissionSaved: 0,
  loadingPerformanceInfo: false,
  emailMarketingStatistic: {
    lastMonthSummary: {
      sent: 0,
      delivered: 0,
      salesDriven: 0
    },
    allSummary: {
      sent: 0,
      delivered: 0,
      salesDriven: 0
    }
  },
  loadingEmailMarketingStatistic: false,
  surveyStats: null,
  surveyStatsThisWeek: null,
  loadingSurveyStats: false,
  openModal: false,
  managePricesUrl: null,
  analyticsInfo: null,
  loadingAnalyticsInfo: false,
  growthModules: null,
  loadingGrowthInfo: false
});

const mainPageReducer = createReducer(
  {
    [GET_TODAY_TOTAL_SALES]: (state) => ({
      ...state,
      loadingTodayTotalSales: true
    }),
    [GET_TODAY_TOTAL_SALES_SUCCESS]: (state, payload) => ({
      ...state,
      todayOrdersCount: payload?.orders || 0,
      todayTotalSales: payload?.totalSum || 0
    }),
    [SET_LOADING_TODAY_TOTAL_SALES]: (state, payload) => ({
      ...state,
      loadingTodayTotalSales: payload
    }),
    [GET_YESTERDAY_TOTAL_SALES]: (state) => ({
      ...state,
      loadingYesterdayTotalSales: true
    }),
    [GET_YESTERDAY_TOTAL_SALES_SUCCESS]: (state, payload) => ({
      ...state,
      yesterdayOrdersCount: payload?.orders || 0,
      yesterdayTotalSales: payload?.totalSum || 0
    }),
    [SET_LOADING_YESTERDAY_TOTAL_SALES]: (state, payload) => ({
      ...state,
      loadingYesterdayTotalSales: payload
    }),
    [GET_ALL_PERIOD_TOTAL_SALES]: (state) => ({
      ...state,
      loadingAllPeriodTotalSales: true
    }),
    [GET_ALL_PERIOD_TOTAL_SALES_SUCCESS]: (state, payload) => ({
      ...state,
      allPeriodOrdersCount: payload?.orders || 0,
      allPeriodTotalSales: payload?.totalSum || 0,
      avrAllPeriodTotalSales: payload?.avgOrderSize || 0
    }),
    [GET_PREV_WEEK_ALL_PERIOD_TOTAL_SALES_SUCCESS]: (state, payload) => ({
      ...state,
      prevWeekAllPeriodOrdersCount: payload?.orders || 0,
      prevWeekAllPeriodTotalSales: payload?.totalSum || 0
    }),
    [SET_LOADING_ALL_PERIOD_TOTAL_SALES]: (state, payload) => ({
      ...state,
      loadingAllPeriodTotalSales: payload
    }),
    [GET_ALL_PERIOD_CUSTOMERS_COUNT]: (state) => ({
      ...state,
      loadingAllPeriodCustomersCount: true
    }),
    [GET_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS]: (state, payload) => ({
      ...state,
      allPeriodCustomersCount: payload?.totalCustomers || 0,
      avgAllPeriodOrdersPerCustomer: payload?.ordersPerCustomer || 0,
      avgAllPeriodItemsPerOrder: payload?.avgItemsPerOrder || 0,
      loadingAllPeriodCustomersCount: false
    }),
    [GET_PREV_WEEK_ALL_PERIOD_CUSTOMERS_COUNT_SUCCESS]: (state, payload) => ({
      ...state,
      prevWeekAllPeriodCustomersCount: payload?.totalCustomers || 0
    }),
    [SET_LOADING_ALL_PERIOD_CUSTOMERS_COUNT]: (state, payload) => ({
      ...state,
      loadingAllPeriodCustomersCount: payload
    }),
    [GET_SALES_PER_HOUR]: (state) => ({...state, loadingSalesPerHour: true}),
    [GET_SALES_PER_HOUR_SUCCESS]: (state, payload) => {
      let peakHours;
      if (Array.isArray(payload) && payload.length > 0) {
        peakHours = findBestAndWorstHour(payload);
      }
      return {
        ...state,
        salesPerHour: payload || [],
        bestHour: peakHours?.bestHour || null,
        bestSales: peakHours?.bestSales || null,
        worstHour: peakHours?.worstHour || null,
        worstSales: peakHours?.worstSales || null,
        loadingSalesPerHour: false
      };
    },
    [SET_LOADING_SALES_PER_HOUR]: (state, payload) => ({
      ...state,
      loadingSalesPerHour: payload
    }),
    [GET_SALES_PER_ITEM]: (state, payload) => ({
      ...state,
      loadingSalesPerItem: true
    }),
    [GET_SALES_PER_ITEM_SUCCESS]: (state, payload) => {
      let result = Array.isArray(payload) ? [...payload] : [];
      if (Array.isArray(payload) && payload.length > 5) {
        result = payload.slice(0, 5);
      }
      return {
        ...state,
        salesPerItem: result || [],
        loadingSalesPerItem: false
      };
    },
    [SET_LOADING_SALES_PER_ITEM]: (state, payload) => ({
      ...state,
      loadingSalesPerItem: payload
    }),
    [GET_TOP_CUSTOMERS]: (state) => ({...state, loadingTopCustomers: true}),
    [GET_TOP_CUSTOMERS_SUCCESS]: (state, payload) => {
      let result = Array.isArray(payload) ? [...payload] : [];
      if (Array.isArray(payload) && payload.length > 4) {
        result = payload
          .sort((a, b) => b?.ordersCount - a?.ordersCount)
          .slice(0, 4);
      }
      return {
        ...state,
        topCustomers: result || [],
        loadingTopCustomers: false
      };
    },
    [SET_LOADING_TOP_CUSTOMERS]: (state, payload) => ({
      ...state,
      loadingTopCustomers: payload
    }),
    [GET_INSIGHTS_PERFORMANCE]: (state) => ({
      ...state,
      loadingPerformanceInfo: true
    }),
    [GET_INSIGHTS_PERFORMANCE_SUCCESS]: (state, payload) => {
      return {
        ...state,
        performanceInfo: Object.keys(INSIGHTS_PERFORMANCE_CARDS_INFO_MAIN_PAGE)
          .filter((el) => payload[el] !== null)
          .map((item) => ({
            title: item,
            value: payload[item] !== null && payload[item] ? payload[item] : 0,
            category: INSIGHTS_PERFORMANCE_CARDS_INFO_MAIN_PAGE[item]?.category
          })),
        loadingPerformanceInfo: false
      };
    },
    [GET_PREV_WEEK_INSIGHTS_PERFORMANCE_SUCCESS]: (state, payload) => {
      return {
        ...state,
        prevWeekCommissionSaved: payload?.commissionsSaved || 0
      };
    },
    [SET_LOADING_INSIGHTS_PERFORMANCE]: (state, payload) => ({
      ...state,
      loadingPerformanceInfo: payload
    }),
    [GET_EMAIL_MARKETING_STATS]: (state) => ({
      ...state,
      loadingEmailMarketingStatistic: true
    }),
    [GET_EMAIL_MARKETING_STATS_SUCCESS]: (state, payload) => ({
      ...state,
      emailMarketingStatistic: payload,
      loadingEmailMarketingStatistic: false
    }),
    [SET_LOADING_EMAIL_MARKETING_STATS]: (state, payload) => ({
      ...state,
      loadingEmailMarketingStatistic: payload
    }),
    [GET_SURVEY_STATS]: (state) => ({...state, loadingSurveyStats: true}),
    [GET_SURVEY_STATS_SUCCESS]: (state, payload) => ({
      ...state,
      surveyStats: payload.data ? payload.data : {},
      loadingSurveyStats: false
    }),
    [GET_SURVEY_STATS_THIS_WEEK_SUCCESS]: (state, payload) => ({
      ...state,
      surveyStatsThisWeek: payload.data ? payload.data : {}
    }),
    [SET_LOADING_SURVEY_STATS]: (state, payload) => ({
      ...state,
      loadingSurveyStats: payload
    }),
    [CLEAR_MAIN_PAGE_DATA]: () => initialState(),
    [SET_OPEN_MODAL]: (state, payload) => ({...state, openModal: payload}),
    [GET_MANAGE_PRICE_URL_SUCCESS]: (state, payload) => {
      return {
        ...state,
        managePricesUrl: payload?.managePrices?.priceComparisonUrl || null,
        growthModules: payload || null,
        loadingGrowthInfo: false
      };
    },
    [SET_LOADING_GROWTH_INFO]: (state, payload) => {
      return {
        ...state,
        loadingGrowthInfo: payload
      };
    },
    [GET_ANALYTICS_INFO]: (state) => {
      return {...state, loadingAnalyticsInfo: true};
    },
    [GET_ANALYTICS_INFO_SUCCESS]: (state, payload) => {
      let peakHours;
      if (
        Array.isArray(payload?.salesByHours) &&
        payload?.salesByHours?.length > 0
      ) {
        peakHours = findBestAndWorstHour(payload?.salesByHours);
      }
      return {
        ...state,
        analyticsInfo: payload,
        bestHour: peakHours?.bestHour || null,
        bestSales: peakHours?.bestSales || null,
        worstHour: peakHours?.worstHour || null,
        worstSales: peakHours?.worstSales || null,
        loadingAnalyticsInfo: false
      };
    },
    [SET_LOADING_ANALYTICS_INFO]: (state, payload) => {
      return {...state, loadingAnalyticsInfo: payload};
    }
  },
  initialState()
);

export default mainPageReducer;
